// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260834/js/" + chunkId + "." + {"44":"d83dc5f6","225":"4a48560b","481":"1353938b","486":"a03a8ab4","770":"92b1e951"}[chunkId] + ".0.3316085431802256.chunk.js";
};